/**
 * User Management translations
 * User management admin page UI text
 */

import { LANGUAGES } from '../config';

export const userManagementTranslations = {
  [LANGUAGES.EN]: {
    title: 'User Management',
    description: 'Manage user accounts, roles, and permissions',
    addUser: 'Add User',
    userManagement: 'User Management',
    nameColumn: 'Name',
    emailColumn: 'Email',
    roleColumn: 'Role',
    managerColumn: 'Manager',
    subordinatesColumn: 'Subordinates',
    registrationRequirement: 'Registration Requirement',
    roleUser: 'User',
    roleManager: 'Manager',
    roleAdmin: 'Administrator',
    roleUnknown: 'Unknown Role',
    editUser: 'Edit User',
    deleteUser: 'Delete User',
    assignManager: 'Assign Manager',
    confirmDelete: 'Are you sure you want to delete this user?',
    userDeleted: 'User deleted successfully',
    userAdded: 'User added successfully',
    userUpdated: 'User updated successfully',
    managerAssigned: 'Manager assigned successfully',
    email: 'Email',
    name: 'Name',
    role: 'Role',
    manager: 'Manager',
    noManager: 'No Manager',
    assignManagerFor: 'Assign a manager for',
    actions: 'Actions',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    lastLogin: 'Last Login',
    never: 'Never',
    searchUsers: 'Search users',
    noUsers: 'No users found',
    userDetails: 'User Details',
    managerDetails: 'Manager Details',
    teamMembers: 'Team Members',
    noTeamMembers: 'No team members found',
    filterByRole: 'Filter by Role',
    filterByManager: 'Filter by Manager',
    roleAnalyst: 'Analyst'
  },
  [LANGUAGES.FR]: {
    title: 'Gestion des utilisateurs',
    description: 'Gerer les comptes, les roles et les permissions des utilisateurs',
    addUser: 'Ajouter un utilisateur',
    userManagement: 'Gestion des utilisateurs',
    nameColumn: 'Nom',
    emailColumn: 'Email',
    roleColumn: 'Role',
    managerColumn: 'Gestionnaire',
    subordinatesColumn: 'Subordonnes',
    registrationRequirement: 'Exigence d inscription',
    roleUser: 'Utilisateur',
    roleManager: 'Gestionnaire',
    roleAdmin: 'Administrateur',
    roleUnknown: 'Role inconnu',
    editUser: 'Modifier l utilisateur',
    deleteUser: 'Supprimer l utilisateur',
    assignManager: 'Assigner un gestionnaire',
    confirmDelete: 'Etes-vous sur de vouloir supprimer cet utilisateur?',
    userDeleted: 'Utilisateur supprime avec succes',
    userAdded: 'Utilisateur ajoute avec succes',
    userUpdated: 'Utilisateur mis a jour avec succes',
    managerAssigned: 'Gestionnaire assigne avec succes',
    email: 'Email',
    name: 'Nom',
    role: 'Role',
    manager: 'Gestionnaire',
    noManager: 'Aucun gestionnaire',
    assignManagerFor: 'Assigner un gestionnaire pour',
    actions: 'Actions',
    status: 'Statut',
    active: 'Actif',
    inactive: 'Inactif',
    lastLogin: 'Derniere connexion',
    never: 'Jamais',
    searchUsers: 'Rechercher des utilisateurs',
    noUsers: 'Aucun utilisateur trouve',
    userDetails: 'Details de l utilisateur',
    managerDetails: 'Details du gestionnaire',
    teamMembers: 'Membres de l equipe',
    noTeamMembers: 'Aucun membre d equipe trouve',
    filterByRole: 'Filtrer par role',
    filterByManager: 'Filtrer par gestionnaire',
    roleAnalyst: 'Analyste'
  }
};
